export const MOCK_SCALAR_CYPHER_RESULT = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:a436116f-02ce-4520-8fbb-7301462a1674:issue/9325906',
									},
								},
								{
									key: 'summary',
									value: '[VULN-1743239] Vulnerability in axios@1.11.0 used by twg-assistant',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{
									key: 'created',
									value: '2023-08-15T14:30:00.000Z',
								},
								{
									key: 'updated',
									value: '2023-09-01T11:20:00.000Z',
								},
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712020:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:7543338:issue/7543338',
									},
								},
								{
									key: 'summary',
									value: 'AGG Specific header for Cost Attribution',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{
									key: 'created',
									value: '2023-07-22T09:00:00.000Z',
								},
								{
									key: 'updated',
									value: '2023-08-28T16:45:00.000Z',
								},
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712020:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287754',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243897: CVE-2025-27152 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{
									key: 'created',
									value: '2023-06-01T18:00:00.000Z',
								},
								{
									key: 'updated',
									value: '2023-06-15T10:00:00.000Z',
								},
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712020:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287755',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243898: CVE-2025-27153 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-02T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-16T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712001:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287756',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243899: CVE-2025-27154 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-03T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-17T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712002:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287757',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243900: CVE-2025-27155 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-04T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-18T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712003:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287758',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243901: CVE-2025-27156 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-05T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-19T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712004:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287759',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243902: CVE-2025-27157 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-06T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-20T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712005:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287760',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243903: CVE-2025-27158 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-07T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-21T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712006:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287761',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243904: CVE-2025-27159 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-08T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-22T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712007:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287762',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243905: CVE-2025-27160 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-09T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-23T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712008:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287763',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243906: CVE-2025-27161 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-10T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-24T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712009:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287764',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243907: CVE-2025-27162 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-11T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-25T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712010:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287765',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243908: CVE-2025-27163 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-12T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-26T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712011:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287766',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243909: CVE-2025-27164 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-13T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-27T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712012:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287767',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243910: CVE-2025-27165 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-14T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-28T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712013:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287768',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243911: CVE-2025-27166 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-15T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-29T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712014:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287769',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243912: CVE-2025-27167 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-16T18:00:00.000Z' },
								{ key: 'updated', value: '2023-06-30T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712015:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287770',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243913: CVE-2025-27168 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-17T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-01T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712016:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287771',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243914: CVE-2025-27169 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-18T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-02T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712017:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287772',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243915: CVE-2025-27170 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-19T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-03T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712018:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287773',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243916: CVE-2025-27171 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-20T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-04T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712019:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287774',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243917: CVE-2025-27172 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'To Do' },
								{ key: 'priority', value: 'High' },
								{ key: 'storyPoints', value: 5 },
								{ key: 'created', value: '2023-06-21T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-05T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712020:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287775',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243918: CVE-2025-27173 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'In Progress' },
								{ key: 'priority', value: 'Medium' },
								{ key: 'storyPoints', value: 8 },
								{ key: 'created', value: '2023-06-22T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-06T10:00:00.000Z' },
								{ key: 'isResolved', value: false },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712021:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'issue',
									value: {
										id: 'ari:cloud:jira:4d7f3154-1d7b-4a16-b859-f1904a19b11f:issue/3287776',
									},
								},
								{
									key: 'summary',
									value:
										'Fed VULN-243919: CVE-2025-27174 - micros/v1/service/app-switcher-bff:/microservice',
								},
								{ key: 'status', value: 'Done' },
								{ key: 'priority', value: 'Low' },
								{ key: 'storyPoints', value: 3 },
								{ key: 'created', value: '2023-06-23T18:00:00.000Z' },
								{ key: 'updated', value: '2023-07-07T10:00:00.000Z' },
								{ key: 'isResolved', value: true },
								{
									key: 'assignee',
									value: {
										id: 'ari:cloud:identity::user/712022:98c0a5d5-5ac5-4637-801c-bba9ddf6cbee',
									},
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: 'a1b2c3d4-e5f6-7890-1234-567890abcdef',
			tId: 'a1b2c3d4e5f678901234567890abcdef',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
} as const;
